import store from "@/store/index.js";
import router from "@/router/index.js";
import { Toast } from 'vant';
import {messages} from '@/lang/lang.js'
const utils = {
	getLanguage() {
        return store.state.language
    },
	$t: (key) => {
		const language = messages[utils.getLanguage()];
		return language[key] || key;
	},
	// 返回上一页
	goBack: (delta = -1) => {
		router?.go(delta);
	},
	// 切换指定页面
	goToPage(pageUrl, options = '') {
		if (!pageUrl) {
			utils.showToast('NoT URL');
			return false
		}
		const url = `/${pageUrl}${options ? '?' + options : ''}`;
		router?.push(url).catch(err => err);
	},
	// 重置指定页面
	reToPage(pageUrl, options = '') {
		if (!pageUrl) {
			utils.showToast('NoT URL');
			return false
		}
		const url = `/${pageUrl}${options ? '?' + options : ''}`;
		router?.replace(url).catch(err => err);
	},
	// 显示提示
	showToast(text) {
		Toast(text);
	},
	// 使用默认浏览器打开网页连接
	openUrl(url, title = "") {
		if (!url) {
			utils.showToast('NoT URL');
			return false;
		}
		// #ifdef H5
		window.open(url)
		// #endif 
	},
	// 强制保留两位小数，不足补零
	returnFloat(value, zNum = 2) {
		var value = Math.round(parseFloat(value) * 100) / 100;
		var strList = value.toString().split(".");
		let integer = strList[0];
		let decimal = strList[1] ? strList[1] : "";
		integer += '.';
		for (let i = 0; i < zNum; i++) {
			if (decimal[i]) {
				integer += decimal[i]
			} else {
				integer += '0'
			}

		}
		return integer;
	},
	// 节流
	throttle(fn, delay = 500) {
		var lastTime;
		var timer;
		var delay = delay || 400;
		return function () {
			var args = arguments;
			// 记录当前函数触发的时间
			var nowTime = Date.now();
			if (lastTime && nowTime - lastTime < delay) {
				clearTimeout(timer);
				timer = setTimeout(function () {
					// 记录上一次函数触发的时间
					lastTime = nowTime;
					// 修正this指向问题
					fn.apply(this, args);
				}, delay);
			} else {
				lastTime = nowTime;
				fn.apply(this, args);
			}
		}
	},
	// 防抖
	debounce(fn, delay = 500) {
		// 记录上一次的延时器
		var timer = null;
		var delay = delay || 200;
		return function () {
			var args = arguments;
			var that = this;
			// 清除上一次延时器
			clearTimeout(timer)
			timer = setTimeout(function () {
				fn.apply(that, args)
			}, delay);
		}
	},
	// 复制文本
	copy(str) {
		if (!str) {
			return
		}
		this.copyContent(str)
	},
	// 复制文本内容方法一
	async copyContent(content) {
		// 复制结果
		let copyResult = true
		// 设置想要复制的文本内容
		const text = content || 'Not Content~';
		// 判断是否支持clipboard方式
		if (!!window.navigator.clipboard) {
			// 利用clipboard将文本写入剪贴板（这是一个异步promise）
			await window.navigator.clipboard.writeText(text).then((res) => {
				this.showToast(utils.$t('弹窗.复制成功'));
			}).catch((err) => {
				console.log('复制失败--采取第二种复制方案', err);
				// clipboard方式复制失败 则采用document.execCommand()方式进行尝试
				copyResult = this.copyContent2(text)
			})
		} else {
			// 不支持clipboard方式 则采用document.execCommand()方式
			copyResult = this.copyContent2(text)
		}
		// 返回复制操作的最终结果
		return copyResult;
	},
	// 复制文本内容方法二
	copyContent2(text) {
		// 复制结果
		let copyResult = true
		// 创建一个input元素
		let inputDom = document.createElement('textarea');
		// 设置为只读 防止移动端手机上弹出软键盘  
		inputDom.setAttribute('readonly', 'readonly');
		// 给input元素赋值
		inputDom.value = text;
		// 将创建的input添加到body
		document.body.appendChild(inputDom);
		// 选中input元素的内容
		inputDom.select();
		// 执行浏览器复制命令
		// 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签中的内容）
		// Input要在正常的编辑状态下原生复制方法才会生效
		const result = document.execCommand('copy')
		// 判断是否复制成功
		if (result) {
			this.showToast(utils.$t('弹窗.复制成功'))
		} else {
			this.showToast(utils.$t('弹窗.复制失败'))
			copyResult = false;
		}
		// 复制操作后再将构造的标签 移除
		document.body.removeChild(inputDom);
		// 返回复制操作的最终结果
		return copyResult;
	},
	// 浏览器入口
	getEntrance() {
		/* 判断入口 */
		let typeApp = "";
		const browser = navigator.userAgent;
		if (
			browser.toLowerCase().match(/Alipay/i) == "alipay" &&
			!browser.toLowerCase().match(/koubei/i)
		) {
			typeApp = "alipay";
		} else if (browser.toLowerCase().match(/eleme/i) == "eleme") {
			typeApp = "eleme";
		} else if (browser.toLowerCase().match(/koubei/i) == "koubei") {
			typeApp = "koubei";
			//@ts-ignore
		} else if (browser.toLowerCase().match(/DingTalk/i) == "dingtalk") {
			typeApp = "dingding";
		} else if (browser.toLowerCase().match(/weibo/i) == "weibo") {
			typeApp = "weibo";
		} else if (browser.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
			typeApp = "weixin";
		} else if (browser.toLowerCase().match(/QQ/i) == 'qq') {
			typeApp = "qq";
		}
		return typeApp;
	},
	getTableData(totalData = [], page = 1, pageSize = 10,) {
		const {
			length
		} = totalData;
		const tableData = {
			data: [],
			page,
			pageSize,
			length,
		};
		// pageSize大于等于总数据长度，说明只有1页数据或没有数据
		// if (pageSize >= length) {
		// 	console.log('pageSize大于等于总数据长度，说明只有1页数据或没有数据');
		// 	tableData.data = totalData;
		// 	//直接取第一页
		// 	tableData.page = 1; 
		// } else {
		// pageSize小于总数据长度，数据多余1页
		// 计算当前页（不含）之前的所有数据总条数
		const num = pageSize * (page - 1);
		if (num < length) {
			// 如果当前页之前所有数据总条数小于（不能等于）总的数据集长度，则说明当前页码没有超出最大页码
			// 当前页第一条数据在总数据集中的索引
			const startIndex = num;
			// 当前页最后一条数据索引
			const endIndex = num + pageSize - 1;
			// 当前页数据条数小于每页最大条数时，也按最大条数范围筛取数据
			tableData.data = totalData.filter((_, index) => index >= startIndex && index <=
				endIndex);
		} else {
			// 当前页码超出最大页码，则计算实际最后一页的page，自动返回最后一页数据
			// 取商
			const size = parseInt(length / pageSize);
			// 取余数
			const rest = length % pageSize;
			// 余数大于0，说明实际最后一页数据不足pageSize，应该取size+1为最后一条的页码
			if (rest > 0) {
				// 当前页码重置，取size+1
				tableData.page = size + 1;
				tableData.data = totalData.filter((_, index) => index >= (pageSize * size) && index <= length);
			} else if (rest === 0) {
				// 余数等于0，最后一页数据条数正好是pageSize
				// 当前页码重置，取size
				tableData.page = size;
				tableData.data = totalData.filter((_, index) => index >= (pageSize * (size - 1)) && index <=
					length);
			} // 注：余数不可能小于0
		}
		// }
		return tableData;
	},
	getBfb(number, allNumber) {
		const result = (Number(number) / Number(allNumber)) * 100;
		return result > 100 ? 100 : parseInt(result);
	},
	fileAutomate(file, eliminate = ['components']) {
		if (!file) return new Error("参数为空或者参数类型错误");
		let fileArr = [];
		file.keys().forEach((path) => {
			let content = file(path).default; // 获取文件 export default 内容
			// console.log(path,path.replace(/.\/(.*?)/,'$1').split('/'),!path.replace(/.\/(.*?)/,'$1').split('/').some(i=>eliminate.includes(i)));
			if (!path.replace(/.\/(.*?)/, '$1').split('/').some(i => eliminate.includes(i))) fileArr.push({ path: path.replace(/.\/(.*?)/, '$1'), content });
		});
		return fileArr;
	},
	groupBy(array, key = 'x') {
		let obj = {}, newArr = [];
		array.forEach(function (item) {
			// 根据对象的属性是唯一的，将值作为对象的属性名
			if (!obj[item[key]]) {
				let arr = [];
				arr.push(item);
				newArr.push(arr);
				obj[item[key]] = item;
			} else {
				newArr.forEach(function (value, index) {
					// 如果已经存在 就循环新组的值将值插入属性相同的数组里 为了防止重复添加 只要和第一个比较就可以了
					if (value[0][key] == item[key]) {
						value.push(item)
					}
				})
			}
		})
		return newArr
	},
	// 计算2点之间的距离
	calculateDistance(x1, y1, x2, y2) {
		const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
		return Number(distance);
	},
	// 查询2个数值 哪个更近于目标值
	getCloserNumber(num1, num2, target) {
		return Math.abs(target - num1) < Math.abs(target - num2) ? num1 : num2;
	},
	// 查询一个数是否在2个数之间
	isBetween(num, number1, number2) {
		const min = Math.min(number1, number2);
		const max = Math.max(number1, number2);
		return num >= min && num <= max;
	}
}

export default utils;